import React from 'react'
import {SearchAlt} from '@styled-icons/boxicons-regular'

import './Search.css';


const Search = ({value, onChange}) => {
  const [user, setUser] = React.useState('')
 
  return (
    <div className="searchcontainer">
    <div className="containerrr">
      <div className="search-box">
        <input type="text" className="search-input" placeholder="Search.." value={value} onChange={onChange}/>
        <button className="search-button">
          <SearchAlt style={{color: 'white'}}/>
        </button>
      </div>
    </div>
    </div>
  );
}

export default Search